module.exports = __webpack_public_path__ + "static/media/ico.c93c4a24.png";